import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo, useState } from 'react';

export const LocaleContext = React.createContext({
    container: null,
});

export const useLocaleContext = () => useContext(LocaleContext) || {};

export const useLocale = () => {
    const { locale, setLocale, unsetLocale, messages, setMessages } = useLocaleContext() || {};
    return { locale, setLocale, unsetLocale, messages, setMessages } || {};
};

const propTypes = {
    children: PropTypes.node.isRequired,
    messages: PropTypes.shape({}),
    locale: PropTypes.string,
};

const defaultProps = {
    messages: null,
    locale: 'fr',
};

export const LocaleProvider = ({ children, locale: initialLocale, messages: initialMessages }) => {
    const [locale, setLocaleState] = useState(initialLocale);
    const [messages, setMessagesState] = useState(initialMessages);

    const setLocale = useCallback(
        (val) => {
            setLocaleState(val);
        },
        [setLocaleState],
    );

    const setMessages = useCallback(
        (val) => {
            setMessagesState(val);
        },
        [setMessagesState],
    );

    const unsetLocale = useCallback(() => {
        setLocaleState(null);
    }, [setLocaleState]);

    const value = useMemo(
        () => ({
            locale,
            setLocale,
            unsetLocale,
            messages,
            setMessages,
        }),
        [locale, setLocaleState, setLocale, unsetLocale, messages, setMessages],
    );
    return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

LocaleProvider.propTypes = propTypes;
LocaleProvider.defaultProps = defaultProps;
